<template>
  <div :class="{ 'has-logo': showLogo }">
    <Logo v-if="showLogo" :collapse="isCollapse" :is-liked="isLiked" />
    <div class="toggle-sidebar-tool" @click="toggleSideBar">
      <i :class="isCollapse ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"></i>
    </div>
    <el-scrollbar slot="reference" wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <SidebarItem
          v-for="(route, index) in leftMenuRoutes"
          :key="route.path + index"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
    <!-- 仿阿里云菜单 -->
    <HoverItem :liked-data="LIKED_DATA" :is-liked="isLiked" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Logo from './Logo';
import SidebarItem from './SidebarItem';
import variables from '@/styles/variables.module.scss';
import HoverItem from './HoverItem.vue';

export default {
  components: { SidebarItem, Logo, HoverItem },
  computed: {
    ...mapGetters(['permission_routes', 'sidebar']),
    leftMenuRoutes() {
      if (this.isLiked) {
        return this.LIKED_DATA;
      }
      const arr = [];
      this.permission_routes.forEach((item) => {
        item.children && item.children.forEach((jitem) => {
          jitem.children && jitem.children.forEach((kitem) => {
            kitem.children = null;
          });
          arr.push(jitem);
        });
      });
      return arr;
    },
    activeMenu() {
      const route = this.$route;

      // 检查工单管理相关路由
      if (route.name && (route.name.indexOf('BusinessWorkorder') > -1 || route.name.indexOf('BusinessOpenWorkorderList') > -1 || route.name.indexOf('BusinessCloseWorkorderList') > -1)) {
        return 'BusinessWorkorder';
      }

      // 检查普通订单相关路由
      if (route.name && (route.name.indexOf('BusinessOrder') > -1 || route.name.indexOf('BusinessAbnormalOrder') > -1)) {
        return 'BusinessOrder';
      }

      // 检查入库管理相关路由
      if (route.name && (route.name.indexOf('BusinessPurchaseOrderCsg') > -1 || route.name.indexOf('BusinessPurchaseTemporary') > -1)) {
        return 'BusinessInbound';
      }

      // 检查采购管理相关路由
      if (route.name && (route.name.indexOf('BusinessPurchase') > -1 || route.name.indexOf('BusinessInventoryPrediction') > -1)) {
        return 'BusinessPurchase';
      }

      // 检查商品审核相关路由
      if (route.name && (route.name.indexOf('BusinessGoodsAudit') > -1)) {
        return 'BusinessGoods';
      }

      // 检查其他路由：使用更精确的匹配逻辑
      if (route.name) {
        const matchedMenu = route.matched.find(matchedRoute => this.leftMenuRoutes.some(item => item.name === matchedRoute.name));
        if (matchedMenu) {
          return matchedMenu.name;
        }

        const result = this.leftMenuRoutes
          .filter(item => {
            if (item.children && Array.isArray(item.children)) {
              return item.children.some(subItem => {
                // 直接匹配路由名称，或者检查路由名称是否包含子路由名称
                return subItem.name === route.name || route.name.indexOf(subItem.name) > -1;
              });
            }
            return false;
          })
          .map(item => item.name);
        return result[0] || '';
      }

      return '';
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
    isLiked() {
      return this.sidebar.liked;
    },
    LIKED_DATA() {
      return this.sidebar.likedData;
    },
  },
  mounted() {
    this.$store.dispatch('app/getLikeData');
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
  },
};
</script>
